// extracted by mini-css-extract-plugin
export var container = "_p-1";
export var copyright = "_p-3";
export var footer = "_p-0";
export var logo = "_p-2";